import ReactDOM from 'react-dom/client';
import App from './App';
import { ReactKeycloakProvider } from '@react-keycloak/web'
import {keycloak, keycloakProviderInitConfig} from './keycloak_config.js'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ReactKeycloakProvider 
    authClient={keycloak} 
    initOptions={keycloakProviderInitConfig}
  >
    <App />
  </ReactKeycloakProvider>
);
